import { render } from "./RegistroDatosPersonales.vue?vue&type=template&id=f308622c"
import script from "./RegistroDatosPersonales.vue?vue&type=script&lang=js"
export * from "./RegistroDatosPersonales.vue?vue&type=script&lang=js"

import "./RegistroDatosPersonales.vue?vue&type=style&index=0&id=f308622c&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__